import { CleverWealth } from "./CleverWealth";

export default CleverWealth;
